import cx from "classnames";
import ShimmerLoading from "src/app/assets/shimmer-loading.json";

import Lottie from "../Lottie";
import styles from "./index.module.scss";

type Props = {
  imageSrc?: string | undefined;
  forTileView?: boolean;
  isLoaded?: boolean;
  handleImageClick?: () => void;
  handleImageLoad?: () => void;
  isMultiTitle?: boolean;
};

function IssueLoader({
  imageSrc,
  handleImageLoad,
  handleImageClick,
  forTileView,
  isLoaded,
  isMultiTitle,
}: Props) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: ShimmerLoading,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className={cx(styles.placeHolderWrapper)}>
      <div
        className={
          forTileView ? cx(styles.tileImageWrapper) : cx(styles.imageWrapper)
        }
      >
        {!isLoaded && (
          <div
            className={cx({
              [styles.mutilTitleIssue]: isMultiTitle,
              [styles["shimmer-image"]]: true,
            })}
            onClick={handleImageClick}
          >
            <Lottie options={defaultOptions} />
          </div>
        )}
        <img
          className={cx({
            [styles.mutilTitleIssue]: isMultiTitle,
          })}
          src={imageSrc}
          alt="issue-img"
          data-testid="issue-img"
          onLoad={handleImageLoad}
          onClick={handleImageClick}
          style={{
            display: isLoaded ? "block" : "none",
          }}
        />
      </div>
    </div>
  );
}

export default IssueLoader;
